export default {
  header: {
    title: 'Código promocional ou cartão de oferta',
  },
  available_codes: {
    title_one: 'Código disponível ({{count}})',
    title_other: 'Códigos disponíveis ({{count}})',
    min_threshold: 'Mín. {{value}}',
    percentage_off: '{{discount}}% de desconto nesta encomenda',
    amount_off: '{{amount}} de desconto nesta encomenda',
  },
  content: {
    input: {
      placeholder: 'Introduzir código',
    },
    buttons: {
      done: 'Concluído',
      apply: 'Aplicar',
      applied: 'Aplicado ✓',
    },
  },
};
